import * as tslib_1 from "tslib";
import { AfterContentInit, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { IncomesService } from 'src/app/shared/services/incomes/incomes.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { OpEnum } from '../../../shared/enums/op.enum';
import { CityModel, HousingTypeModel } from '../../../shared/models/abre-cuentas.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from '../../../shared/services/capture/capture.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { StringHelperService } from '../../../shared/services/helpers/string-helper.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
var FormUbicationInfoComponent = /** @class */ (function () {
    /**
     * Summary Initialize Services
     * @param formBuilder
     * @param abreCuentasNavigationService
     * @param parametersService
     * @param appService
     * @param abreCuentasService
     */
    function FormUbicationInfoComponent(copyService, formBuilder, navigationService, stringHelperService, abreCuentasService, parametersService, headerService, captureService, incomesService, validationHelperService, requestService) {
        this.copyService = copyService;
        this.formBuilder = formBuilder;
        this.navigationService = navigationService;
        this.stringHelperService = stringHelperService;
        this.abreCuentasService = abreCuentasService;
        this.parametersService = parametersService;
        this.headerService = headerService;
        this.captureService = captureService;
        this.incomesService = incomesService;
        this.validationHelperService = validationHelperService;
        this.requestService = requestService;
        this.showFields = false;
        this.headerService.show(true, true, true);
        this.district_option = this.abreCuentasService.getDistricts();
        this.formGroup = this.formBuilder.group({});
    }
    /**
     * Summary Charge data for contact and set in false Selected Option
     */
    FormUbicationInfoComponent.prototype.ngOnInit = function () {
        this.selectedOccupation = this.abreCuentasService.getOccupationSelected();
        this.has_second_headline = this.abreCuentasService.getSecondHeadline();
        var productSelected = this.abreCuentasService.getproductSelected();
        if (productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING ||
            productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_FREE ||
            productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_TC ||
            productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING ||
            productSelected.product_type === BUSINESS_CONST.MULTI ||
            productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN) {
            this.optionsHousingType = this.parametersService.getSetting(OpEnum.HOUSING_TYPE);
            this.optionsStratum = this.parametersService.getSetting(OpEnum.STRATUM);
            this.showFields = true;
            this.formGroup = new FormGroup({
                'input-value-address': new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(40), Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/))]),
                'input-value-addressDetail': new FormControl(''),
                'housing-selection': new FormControl('', Validators.required),
                'stratum-selection': new FormControl('', Validators.required),
            });
        }
        else {
            this.formGroup = new FormGroup({
                'input-value-address': new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(40), Validators.pattern(new RegExp(/^[Ññ\w-#/., ]+$/))]),
                'input-value-addressDetail': new FormControl(''),
            });
        }
        // this.options = this.parametersService.getSetting(OpEnum.CITY_LIST);
        this.contactInfo = (typeof this.has_second_headline === 'undefined' || !this.has_second_headline.has_second_headline)
            ? this.abreCuentasService.getContactInfo()
            : this.abreCuentasService.getContactInfoSecondHeadline();
        if (this.contactInfo.address !== undefined && this.contactInfo.address.city !== undefined) {
            this.selectedCity = this.contactInfo.address.city;
            this.selected_district = this.selectedCity.district_id;
            this.selectedHousingType = this.contactInfo.address.housingType !== undefined ?
                this.contactInfo.address.housingType : {
                housingId: '',
                description: '',
            };
            this.selectedStratum = this.contactInfo.address.stratum !== undefined ? this.contactInfo.address.stratum : '';
            this.contactInfo.mobile_number = this.contactInfo.mobile_number !== undefined ? this.contactInfo.mobile_number : '';
            return;
        }
        this.contactInfo.address = {
            city: new CityModel(),
            address: '',
            detail: '',
            addressInput: '',
            stratum: '',
            housingType: new HousingTypeModel(),
        };
        this.selectedCity = {
            city_code: '',
            country_code: '',
            province_code: 0,
            description: '',
        };
        this.selectedHousingType = {
            housingId: '',
            description: '',
        };
        this.selectedStratum = '';
    };
    FormUbicationInfoComponent.prototype.ngAfterContentInit = function () {
        var controladdress = this.formGroup.controls['input-value-address'];
        var controladdressdetail = this.formGroup.controls['input-value-addressDetail'];
        controladdress.setValue(this.contactInfo.address.addressInput);
        controladdressdetail.setValue(this.contactInfo.address.detail);
    };
    /**
     * Evento de cambio de dirección
     *
     * *Summary Address entry change event, error validation*
     */
    FormUbicationInfoComponent.prototype.reactiveInputChangeAddress = function () {
        var controladdress = this.formGroup.controls['input-value-address'];
        controladdress.setValue(controladdress.value.replace(/[^A-Za-z0-9\s#\-.]/g, '').replace(/\s{2,}/g, ' '));
        this.setContactInfo();
    };
    /**
     * Normalizar dirección
     *
     * *Summary normalize address*
     * @returns {string}
     */
    FormUbicationInfoComponent.prototype.validateAddress = function () {
        var controladdress = this.formGroup.controls['input-value-address'];
        var controladdressdetail = this.formGroup.controls['input-value-addressDetail'];
        return this.stringHelperService.normalizeAddress(controladdress.value, controladdressdetail.value);
    };
    /**
     * event mail entry change, error validation
     */
    FormUbicationInfoComponent.prototype.next = function () {
        var _this = this;
        this.setContactInfo();
        var productSelected = this.abreCuentasService.getproductSelected();
        if (productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LIVING) {
            this.navigationService.nextStep('200');
            return;
        }
        this.captureService.sendProspectOccupationUbicationInfo(this.contactInfo).then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.abreCuentasService.viewOptionMultiProduct ||
                            productSelected.product_type === BUSINESS_CONST.PRODUCT_TYPE_LOAN)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.incomesService.callIncomes()
                                .then(function (response) {
                                if (response === '200') {
                                    if (_this.abreCuentasService.getPostlogin() &&
                                        !_this.validationHelperService.validateMailPhone()) {
                                        _this.navigationService.navigateToGeneralInformation('512');
                                    }
                                    else {
                                        _this.switchCode();
                                    }
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        this.navigationService.nextStep('200');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); }).catch(function () { return _this.navigationService.navigateToGeneralInformation('500'); });
    };
    /**
     * Summary Event for select a option for list selected, and set value in Input
     * @param option
     */
    FormUbicationInfoComponent.prototype.selectOptionHousing = function (event) {
        if (event.value) {
            this.selectedHousingType = { housingId: event.value.id, description: event.value.name };
            this.setContactInfo();
        }
        else {
            this.selectedHousingType = { housingId: '', description: '' };
        }
    };
    /**
     * Summary Event for select a option for list selected, and set value in Input
     * @param option
     */
    FormUbicationInfoComponent.prototype.selectOptionStratum = function (event) {
        if (event.value) {
            this.selectedStratum = event.value.name;
            this.setContactInfo();
        }
        else {
            this.selectedStratum = '';
        }
    };
    /**
     * Summary Event for select a option for list selected, and set value in Input
     * @param option
     */
    FormUbicationInfoComponent.prototype.selectOption = function (event) {
        if (event.value) {
            this.selectedCity = this.options.find(function (e) { return e.city_code === event.value.city_code && e.province_code === event.value.province_code; });
            this.setContactInfo();
        }
        else {
            this.selectedCity = { city_code: '', country_code: '', province_code: 0, description: '' };
        }
    };
    /**
     * charge in contactModel the form data
     */
    FormUbicationInfoComponent.prototype.setContactInfo = function () {
        this.contactInfo = {
            mobile_number: this.contactInfo.mobile_number !== undefined ? this.contactInfo.mobile_number : '',
            email: this.contactInfo.email,
            employment_number: '',
            address: {
                city: this.selectedCity,
                addressInput: this.formGroup.controls['input-value-address'].value,
                detail: this.formGroup.controls['input-value-addressDetail'].value,
                address: this.validateAddress(),
                stratum: this.selectedStratum !== undefined ? this.selectedStratum : '',
                housingType: {
                    housingId: this.selectedHousingType !== undefined ? this.selectedHousingType.housingId : '',
                    description: this.selectedHousingType !== undefined ? this.selectedHousingType.description : '',
                },
            },
        };
        this.has_second_headline ? this.abreCuentasService.setContactInfoSecondHeadline(this.contactInfo)
            : this.abreCuentasService.setContactInfo(this.contactInfo);
    };
    FormUbicationInfoComponent.prototype.switchCode = function () {
        switch (this.abreCuentasService.getOccupationSelected().id) {
            case 1:
                this.navigationService.nextStep('201');
                break;
            case 2:
                this.navigationService.nextStep('202');
                break;
            case 5:
                this.navigationService.nextStep('200');
                break;
            default:
                this.navigationService.nextStep();
                break;
        }
    };
    FormUbicationInfoComponent.prototype.getCitys = function (provence_id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestService.cityBranches(provence_id).then(function (responseU) {
                            _this.city_option = responseU.body;
                            _this.options = _this.city_option.map(function (data) {
                                var codeDaneUbication = data.code_dane;
                                var codeDanelength = codeDaneUbication.length - 3;
                                return {
                                    city_code: codeDaneUbication.substring(codeDanelength),
                                    province_code: +codeDaneUbication.substring(0, codeDanelength),
                                    description: data.city,
                                    district_id: data.district.district_id,
                                };
                            });
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FormUbicationInfoComponent.prototype.selectOptionProvidence = function (event) {
        var valueUbication = event.value;
        if (valueUbication && valueUbication.trim() !== '') {
            this.selected_district = valueUbication;
            this.getCitys(valueUbication);
        }
        else {
            this.city_option = undefined;
            this.selectedCity = { city_code: '', country_code: '', province_code: 0, description: '' };
            this.selected_district = undefined;
        }
    };
    return FormUbicationInfoComponent;
}());
export { FormUbicationInfoComponent };
